import React, { useState, useEffect, useContext, Fragment , useRef, useCallback} from "react";
import { Link } from 'react-router-dom';
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button } from "react-bootstrap";
import Regex from 'services/utils/regex/Regex';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Layout from 'components/sales/layout/layout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { toast } from "react-toastify";
import { add } from "date-fns";
import axios from "axios";
import Config from "services/config/config";
import FileUpload from "components/sales/fileUpload/fileUpload";

const AddClient = ({ match, locationPinCode, pincodeData, addClient, 
    documentUploadUrl,
    documentUrlData,
    documentUploadUrlPublic,
    documentUrlDataPublic,  }) => {
    const [isLoading, setIsLoading] = useState(false);
    const { baseUrl } = useContext(BaseUrl);
    const [isModal, setIsModal] = useState(false);
    const [data, setData] = useState({ client_name: '', pan_number: '', poc_name: '', poc_des: '', poc_number: '', poc_email: '', includeInMail: '', gst_number: '', pin_code: '', locality: '', state: '', city: '', tan_number: '', confirm_tan_number: '', tan_attachment: '' })
    const [isNewPan, setIsNewPan] = useState(false);
    const [isPanSelected, setIsPanSelected] = useState(false);
    const [clientPanDetails,  setClientPanDetails] = useState({});
    const [isNewGst, setIsNewGst] = useState(false);
    const [isGstSelected, setIsGstSelected] = useState(0);
    const [isGstValidated, setIsGstValidated] = useState(false);
    const [addressOptions, setAddressOptions] = useState([]);
    const [isAddressSelected, setIsAddressSelected] = useState(false);
    const [selectedAddress,setSelectedAddress] = useState(null);
    const [clientRegisteredName, setClientRegisteredName] = useState(false);
    const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]$/i;

    useEffect(() => {
        let regex = new RegExp(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/)
        if (regex.test(data?.pin_code)) {
            (async () => {
                setIsLoading(true)
                await locationPinCode(data?.pin_code)
                setIsLoading(false)
            })()
        }
    }, [data?.pin_code])

    useEffect(() => {
        setData({ ...data, state: pincodeData[0]?.state_name, city: pincodeData[0]?.city_name })
    }, [pincodeData])

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (data?.gst_number) {
                setIsGstValidated(false);
                setIsNewPan(false);
                setIsPanSelected(false);
            }
        }, 500);
    
        return () => clearTimeout(timeout);
    }, [data?.gst_number]);

    const headerBtns = () => {
        return (
            <Fragment>
                <Button
                    onClick={handleSubmit}
                    className="filter-hamburger filter-btn btn btn-transparent"
                >
                    {localization.submit}
                </Button>

            </Fragment>
        );
    };

    const handleSubmit = () => {
        if (data?.client_name == '' || data?.client_name.trim().length == 0 || data?.client_name == null) {
            toast.error('Client Name')
            return;
        }
        if(isNewPan === true && data?.pan_number){
            let regex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
            if ((!regex.test(data?.pan_number)) || data?.pan_number == null) {
                toast.error('Invalid PAN Number')
                return;
            }
        }
        let regex = new RegExp(/^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/)
        if (!regex.test(data?.pin_code) || data?.pin_code == null) {
            toast.error('Invalid Pin Code')
            return;
        }
        if (data?.locality == '' || data?.locality == null) {
            toast.error('Address Line 1')
            return;
        }
        if (data?.poc_name == '' || data?.poc_name == null || data?.poc_des == '' || data?.poc_des == null || data?.poc_email == '' || data?.poc_email == null || data?.poc_number == '' || data?.poc_number == null || data?.includeInMail == '' || data?.includeInMail == null) {
            toast.error('Fill POC Details')
            return;
        }
        if (data?.locality == '' || data?.locality == null) {
            toast.error('Fill Address')
            return;
        }
        else {
            (async () => {
                setIsLoading(true)
                const res = await addClient(data)
                if (res) {
                    setIsModal(true)
                }
                setIsLoading(false)
            })()
        }
    }

    const handleCheckPan = async () => {
        try {
            if (!data?.pan_number) {
                toast.error('PAN number is required');
                return false;
            }
            const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
            if (data.pan_number.length === 10 && !panRegex.test(data.pan_number)) {
                toast.error("Invalid PAN format. It should be like ABCDE1234F.");
                return false;
            } else if (data.pan_number.length !== 10) {
                toast.error("Invalid PAN length.");
                return false;
            }
            setIsLoading(true);
            setIsNewPan(false);
            const response = await axios.get(`${Config.client.getClientByPan}?client_pan=${data.pan_number}`);
            if (response !== null && response?.data) {
                const panPayload = response?.data?.response?.data ?? response?.data?.data;
                if (panPayload?.clients?.length > 0) {
                    setIsLoading(false);
                    toast.error("PAN number already exists");
                    return false;
                } else if (
                    (response?.data?.status === false || response?.data?.status === 1) &&
                    response?.data?.message === 'Pan number is invalid'
                ) {
                    setIsLoading(false);
                    setClientPanDetails({});
                    toast.error(response?.data?.message);
                    return false;
                } else {
                    setData({ ...data, client_name: panPayload?.registered_name });
                    setClientPanDetails(panPayload);
                    setIsNewPan(true);
                    if (panPayload?.registered_name === null) {
                        setClientRegisteredName(false);
                    }
                    else {
                        setClientRegisteredName(true);
                    }
                }
            }
            setIsLoading(false);
        } catch (err) {
            const errMsg = err?.response?.data?.message ?? err?.response?.data?.response?.message;
            if (errMsg === 'Pan number is invalid') {
                setIsLoading(false);
                setClientPanDetails({});
                toast.error(errMsg);
                return false;
            }
            setIsLoading(false);
            toast.error("Error in checking PAN Number");
            return;
        }
    }

    useEffect(()=>{
        if (selectedAddress?.value !== 'Other') {
            setIsNewPan(true);
            const selected = addressOptions.find(opt => opt.id === selectedAddress.id);
            if (selected) {
                setData({
                    ...data,
                    state: selected.state,
                    city: selected.city,
                    pin_code: selected.pincode,
                    locality: selected.addressLine1,
                });
            }
        }
        else{
            setIsNewPan(true);
            setData({
                ...data,
                pin_code: '',
                locality: '',
            });
        }
    },[selectedAddress])

    useEffect(()=>{
        setIsGstValidated(false);
        setIsNewPan(false);
    },[isGstSelected])

    const handleCheckGst = useCallback(async () => {
        let cancelled = false;
        setIsLoading(true);
      
        try {
          const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
          if (!data?.gst_number || data.gst_number.length !== 15 || !gstRegex.test(data.gst_number)) {
            toast.error("Invalid GST number");
            setIsLoading(false);
            return;
          }
      
          const response = await axios.get(`${Config.client.getDetailsByGst}?gst=${data.gst_number}`);
          const result = response?.data?.response;

          if (!cancelled && result?.data && result?.data?.pan_details && result?.data?.pan_details?.clients && result?.data?.pan_details.clients.length > 0) {
                setIsLoading(false);
                toast.error("PAN number already exists");
                return false;
            }
      
          else if (!cancelled && result?.status) {
            const addressList = result.data?.address ?? [];
            const pan = result.data?.pan ?? '';
            setAddressOptions(addressList);
            setSelectedAddress(null); 
            setClientPanDetails(result?.data?.pan_details);
            setIsAddressSelected(false);
            setIsGstValidated(true);
            setIsPanSelected(1);
            setData({ ...data, client_name: result.data?.pan_details?.registered_name });
            setData(prev => ({
              ...prev,
              pan_number: pan.toUpperCase(),
            }));
          } else if (!cancelled) {
            toast.error(result?.message || "GST validation failed");
            setIsGstValidated(false);
            setClientPanDetails({});
          }
        } catch (error) {
          if (!cancelled) {
            toast.error("Invalid or Inactive GST");
          }
        } finally {
          if (!cancelled) setIsLoading(false);
        }
      
        return () => {
          cancelled = true;
        };
      }, [data?.gst_number]);
      
    return (
        <Layout
            title={localization.clientList}
            Buttons={headerBtns}
            //className={isFiled ? 'requiredFileds' : ''}
            isGoback
            isLoading={isLoading}
            style={{}}
        >
            <div className="panel-card card-details" width="100%">
                <div className="panel-heading">{localization.addClient}</div>
                <div className="panel-body">
                    <div className="details-listing detail_alignment">
                        <div className='row'>
                        <div className='col-md-6'>
                                <DropDownInput
                                    data={[{ id: 1, name: "Yes" }, { id: 2, name: "No" }]}
                                    label={localization.gstConfirmation}
                                    required
                                    getIdValue={(val) => {
                                        setIsNewGst(false);
                                        setIsGstSelected(val.id);
                                        setIsPanSelected(false);
                                    }}
                                    isStarRequired={true}
                                />
                            </div>
                            {isGstSelected === 1 &&
                                <>
                                    <div className='col-md-6'>
                                        <ConstantInput
                                            label='Enter GST Number' 
                                            value={data?.gst_number}
                                            type="text"
                                            handleChange={(value) => {
                                                setData({ ...data, gst_number: value.toUpperCase() });
                                            }}
                                            isStarRequired={true}
                                        />
                                    </div>
                                    {!isGstValidated && 
                                    <>
                                    <div className='col-md-6'>
                                        <div className="form-group">
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="form-group">
                                        <a className="btn btn-theme mb-2 btn-sm" onClick={handleCheckGst}>
                                            Check GST
                                        </a>
                                        </div>
                                    </div>
                                    </>
                                    }
                                </>
                            }    

                            {(isGstSelected ==2 ) &&
                            <div className='col-md-6'>
                                <DropDownInput
                                    data={[{ id: 1, name: "Yes" }, { id: 2, name: "No" }]}
                                    label={localization.isPanNumberReq}
                                    required
                                    errorMsg={localization.errorPanReq}
                                    getIdValue={(val) => {
                                        setIsNewPan(false);
                                        setIsPanSelected(val.id);
                                    }}
                                    isStarRequired={true}
                                />
                            </div>
                            }
                            {isPanSelected === 1 &&
                                <>
                                    <div className='col-md-6'>
                                        <ConstantInput
                                            label={localization.requiredPan}
                                            value={data?.pan_number}
                                            id="pan_no" 
                                            type="text"
                                            handleChange={(value) => {
                                                setData({ ...data, pan_number: value.toUpperCase() });
                                            }}
                                            isStarRequired={true}
                                            disabled={isGstValidated == true && data?.pan_number}
                                        />
                                    </div>
                                    {(isGstSelected == 2) &&
                                        <>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className="form-group">
                                                <a className="btn btn-theme mb-2 btn-sm" onClick={handleCheckPan}>
                                                    {localization.checkPan}
                                                </a>
                                                </div>
                                            </div>
                                        </>
                                    }

                                    {(isGstSelected == 1 && isGstValidated) &&
                                        <div className='col-md-6'>
                                            <DropDownInput
                                                data={addressOptions}
                                                label="Select address"
                                                required
                                                getIdValue={(val) => {
                                                    if (val) {
                                                        setSelectedAddress(val);
                                                        setIsAddressSelected(true);
                                                    } else {
                                                        setSelectedAddress(null);
                                                        setIsAddressSelected(false);
                                                    }
                                                }}
                                                isStarRequired={true}
                                            />
                                        </div>
                                    }
                                </>
                            }

                            {(isPanSelected === 2 || isNewPan === true) &&
                                <>
                                    <div className='col-md-6'>
                                        <ConstantInput
                                            label='Client Name (Billing registered name)'
                                            value={data?.client_name}
                                            type="text"
                                            handleChange={(value) => {
                                                setData({ ...data, client_name: value });
                                            }}
                                            isStarRequired={true}
                                            disabled={(clientPanDetails?.registered_name != null && clientPanDetails?.registered_name != '') ? true : false}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                        label={localization.tanNumber}
                                        type="password"
                                        handleChange={(val) => {
                                            setData({
                                            ...data,
                                            tan_number: val,
                                            });
                                        }}
                                        onPaste={(e) => e.preventDefault()}
                                        />
                                        {data?.tan_number && !tanRegex.test(data?.tan_number) && (
                                            <div style={{ color: 'red' }}>Invalid TAN number format</div>
                                        )}
                                    </div>
                                    <div className="col-md-6">
                                        <ConstantInput
                                        label={localization.confirmTanNumber}
                                        maxLength={10}
                                        handleChange={(val) => {
                                            setData({
                                            ...data,
                                            confirm_tan_number: val,
                                            });
                                        }}
                                        onPaste={(e) => e.preventDefault()}
                                        />
                                        {data?.confirm_tan_number &&
                                        data?.tan_number !== data?.confirm_tan_number && (
                                            <div style={{ color: 'red' }}>TAN numbers do not match</div>
                                        )}
                                    </div>
                                    <FileUpload
                                    id="docs"
                                    accept=".pdf,.png,.jpg"
                                    documentUploadUrl={documentUploadUrlPublic}
                                    documentUrlData={documentUrlDataPublic}
                                    onChange={(val) => {
                                        setData({ ...data, tan_attachment: val });
                                    }}
                                    prefilledFilename={data.tan_attachment}
                                    required
                                    >
                                    <span className="btn btn-transparent">
                                        {localization.tanAttachment}
                                    </span>
                                    </FileUpload>
                                </>
                            }
                        </div>
                        {(isPanSelected === 2 || isNewPan === true) &&
                            <>
                                <div className="panel-card card-details" width="100%">
                                    <div className="panel-heading">POC Details</div>
                                    <div className="panel-body">
                                        <div className="details-listing detail_alignment">
                                            <div className="row">
                                                <div className='col-md-6'>
                                                    <ConstantInput
                                                        label='POC Name'
                                                        value={data?.poc_name}
                                                        type="text"
                                                        handleChange={(value) => {
                                                            setData({ ...data, poc_name: value });
                                                        }}
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <ConstantInput
                                                        label='POC Designation'
                                                        value={data?.poc_des}
                                                        type="text"
                                                        handleChange={(value) => {
                                                            setData({ ...data, poc_des: value });
                                                        }}
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <ConstantInput
                                                        label='Phone Number'
                                                        value={data?.poc_number}
                                                        type="number"
                                                        handleChange={(value) => {
                                                            setData({ ...data, poc_number: value });
                                                        }}
                                                        regex={Regex.phoneNumber.test(data.poc_number)}
                                                        errorMsg={localization.numericError}
                                                        maxLength={10}
                                                        minLength={10}
                                                        tenDigitsValidation={true}
                                                        className="countrycode"
                                                        isPrefix
                                                        prefixText={'+91'}
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <ConstantInput
                                                        label='Email Address (Invoices to be send on this email id)'
                                                        value={data?.poc_email}
                                                        type="text"
                                                        handleChange={(value) => {
                                                            setData({ ...data, poc_email: value });
                                                        }}
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className='col-md-6'>
                                                    <DropDownInput
                                                        data={[{ id: "Yes", name: "Yes" }, { id: "No", name: "No" }]}
                                                        label="Include in Mail Campaign"
                                                        required
                                                        errorMsg={localization.requiredName}
                                                        getIdValue={(val) => {
                                                            setData({ ...data, includeInMail: val.id })
                                                        }}
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                {/* { (!isGstSelected) &&
                                                <div className='col-md-6'>
                                                    <ConstantInput
                                                        label='GST Number'
                                                        value={data?.gst_number}
                                                        type="text"
                                                        handleChange={(value) => {
                                                            setData({ ...data, gst_number: value });
                                                        }}
                                                    />
                                                </div>
                                            } */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="panel-card card-details" width="100%">
                                    <div className="panel-heading">{localization.billedTo}</div>
                                    <div className="panel-body">
                                        <div className="details-listing detail_alignment">
                                            <div className="row">
                                                <div className='col-md-4'>
                                                    <ConstantInput
                                                        label='Pin Code'
                                                        value={data?.pin_code}
                                                        regex={Regex.pinCode.test(data?.pin_code)}
                                                        type="number"
                                                        handleChange={(value) => {
                                                            setData({ ...data, pin_code: value });
                                                        }}
                                                        isStarRequired={true}
                                                        disabled={isGstValidated == true && selectedAddress?.value!='Other'}
                                                        // disabled={isGstValidated == true}
                                                    />
                                                </div>
                                                <div className='col-md-4'>
                                                    <ConstantInput
                                                        label='Geographical State'
                                                        disabled={true}
                                                        value={(selectedAddress?.value === 'Other' && pincodeData == []) ? '' : pincodeData[0]?.state_name || ''}
                                                        // value={pincodeData == [] ? '' : pincodeData[0]?.state_name || ''}
                                                        type="text"
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className='col-md-4'>
                                                    <ConstantInput
                                                        label='Geographical City'
                                                        disabled={true}
                                                        // value={(selectedAddress?.value === 'Other' && pincodeData == []) ? '' : pincodeData[0]?.city_name || ''}
                                                        value={pincodeData == [] ? '' : pincodeData[0]?.city_name || ''}
                                                        type="text"
                                                        isStarRequired={true}
                                                    />
                                                </div>
                                                <div className='col-md-12'>
                                                    <ConstantInput
                                                        label='Address'
                                                        value={data?.locality}
                                                        type="text"
                                                        handleChange={(value) => {
                                                            setData({ ...data, locality: value });
                                                        }}
                                                        isStarRequired={true}
                                                        disabled={isGstValidated == true && selectedAddress?.value!='Other'}
                                                        // disabled={isGstValidated == true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>

            <ModalPop
                title=""
                show={isModal}
                handleModalHide={() => setIsModal(false)}
            >
                <div className="text-center">
                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>
                    <h5>Client Info Saved Successfully</h5>
                    <Link to={`${baseUrl}/client-list`} className="btn btn-primary mb-4">View Client Listing</Link>
                </div>
            </ModalPop>
        </Layout>
    )
}

export default AddClient